// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"208":"success","251":"checkout","779":"error","870":"wishlist"}[chunkId] + "." + {"208":"8d3f54cb","251":"b499fec0","779":"2bad2fba","870":"5d99f1ee"}[chunkId] + ".css";
};